var _defs, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.61 37.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: red;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 4.5px;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.25,
    y1: 2.25,
    x2: 35.36,
    y2: 35.36
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.25,
    y1: 35.36,
    x2: 35.36,
    y2: 2.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorX);
export default __webpack_public_path__ + "static/media/errorX.0cbb855e05ae036c896f1c755b1d908a.svg";
export { ForwardRef as ReactComponent };